<script setup>
const route = useRoute()
const { data: page } = await useAsyncData(route.path, () =>
  queryCollection('content').path(route.path).first(),
)
const { data: surround } = await useAsyncData(
  `${route.path}-surround`,
  async () => {
    const surround = await queryCollectionItemSurroundings(
      'content',
      route.path,
    )

    return surround ?? []
  },
)

function goBack() {
  window.history.back()
}

useHead({
  titleTemplate: '%s',
})
</script>

<template>
  <UContainer>
    <UPage v-if="page">
      <UPageHeader :title="page.title">
        <template #description>
          {{ page.description }}
          <br />
          <br />
          <UButton
            class="pl-0"
            variant="link"
            leading-icon="lucide:arrow-left"
            @click="goBack"
          >
            Back
          </UButton>
        </template>
      </UPageHeader>
      <UPageBody>
        <article class="prose max-w-full">
          <ContentRenderer :value="page" />
        </article>
        <template v-if="Array.isArray(surround) && surround.length > 0">
          <USeparator />
          <UContentSurround :surround="surround" />
        </template>
      </UPageBody>
      <template #right>
        <UContentToc
          :links="page.body.toc.links"
          :ui="{
            root: 'top-0',
          }"
        />
      </template>
    </UPage>
  </UContainer>
</template>
